angular.module('app')
    .component('verdictPassIcon', {
        template: function () {
            var verdict = [
                '<span class="fa-stack fa-lg">',
                '<i class="fa fa-plus fa-stack-1x " style="top:-0.35em;"></i>',
                '<i class="fa fa-check fa-stack-2x " style="top:0.35em;"></i>',
                '</span>'
            ].join('');
            return verdict;
        }
    });